const en = {
  title: 'Quality Overview',
  subtitle: 'Understand results, find failures, and decide what to test next.',
  allProjects: 'All accessible projects',
  project: 'Project',
  type: 'Test type',
  allTypes: 'API & Flow',
  api: 'API',
  flow: 'Flow',
  period: 'Period',
  days: 'days',
  refresh: 'Refresh',
  loading: 'Loading quality metrics…',
  error: 'Unable to load quality metrics. Please try again.',
  retry: 'Try again',
  reset: 'Reset filters',
  visibleTests: 'visible tests',
  updated: 'Updated',
  attentionNeeded: 'Needs attention',
  resultsAvailable: 'Results available',
  noRecentData: 'No recent results',
  completed: 'Completed executions',
  completedHint: 'Passed + failed in selected period',
  passed: 'passed',
  failed: 'failed',
  successRate: 'Execution success rate',
  successHint: 'Passed / completed executions',
  noCompleted: 'No completed executions in this period',
  failing: 'Currently failing tests',
  failingHint: 'Latest completed result, across all history',
  neverRun: 'Tests never run',
  neverHint: 'No execution history, across all history',
  attention: 'Needs Attention',
  attentionHint: 'Prioritized by repeated failures, latest failures, and missing runs.',
  repeated_failure: 'Repeated failures in selected period',
  latest_failed: 'Latest completed execution failed',
  never_run: 'No execution history',
  stale: 'No dated execution in selected period',
  noAttention: 'No failing or untested items to highlight in this scope.',
  showing: 'Showing',
  of: 'of',
  breakdown: 'Failure Breakdown',
  breakdownHint: 'Top projects by failed executions in selected period.',
  noFailures: 'No failed executions in this period.',
  health: 'Project Health',
  healthHint:
    'Execution counts use the selected period. Failing tests use their latest completed result.',
  tests: 'Tests',
  completedShort: 'Completed',
  failingShort: 'Failing tests',
  neverShort: 'Never run',
  lastRun: 'Last run',
  noProjects: 'No tests in this scope yet.',
  activity: 'Recent Activity',
  activityHint: 'Latest execution activity in selected period.',
  noActivity: 'No execution activity in this period.',
  history: 'Open test history',
  openError: 'Unable to open this test. Refresh and try again.',
  uncategorized: 'Uncategorized',
  unavailable: 'Unavailable project',
  filtersHint:
    'Metrics include only tests you can access. Pending, running, cancelled, and untested items are excluded from the success rate.',
  status: {
    pass: 'Passed',
    passed: 'Passed',
    fail: 'Failed',
    failed: 'Failed',
    error: 'Error',
    pending: 'Pending',
    running: 'Running',
    cancelled: 'Cancelled',
    canceled: 'Cancelled',
    unknown: 'Unknown',
  },
};

const es = {
  title: 'Resumen de calidad',
  subtitle: 'Revisa resultados, identifica fallos y decide qué probar después.',
  allProjects: 'Todos los proyectos accesibles',
  project: 'Proyecto',
  type: 'Tipo de prueba',
  allTypes: 'API y Flow',
  api: 'API',
  flow: 'Flow',
  period: 'Período',
  days: 'días',
  refresh: 'Actualizar',
  loading: 'Cargando métricas de calidad…',
  error: 'No se pudieron cargar las métricas. Inténtalo de nuevo.',
  retry: 'Reintentar',
  reset: 'Restablecer filtros',
  visibleTests: 'pruebas visibles',
  updated: 'Actualizado',
  attentionNeeded: 'Requiere atención',
  resultsAvailable: 'Resultados disponibles',
  noRecentData: 'Sin resultados recientes',
  completed: 'Ejecuciones completadas',
  completedHint: 'Aprobadas + fallidas en el período seleccionado',
  passed: 'aprobadas',
  failed: 'fallidas',
  successRate: 'Tasa de éxito de ejecuciones',
  successHint: 'Aprobadas / ejecuciones completadas',
  noCompleted: 'Sin ejecuciones completadas en este período',
  failing: 'Pruebas con fallos actuales',
  failingHint: 'Último resultado completado de todo el historial',
  neverRun: 'Pruebas nunca ejecutadas',
  neverHint: 'Sin historial de ejecuciones',
  attention: 'Requiere atención',
  attentionHint: 'Prioridad: fallos repetidos, último resultado fallido y falta de ejecuciones.',
  repeated_failure: 'Fallos repetidos en el período',
  latest_failed: 'La última ejecución completada falló',
  never_run: 'Sin historial de ejecuciones',
  stale: 'Sin ejecución con fecha en el período',
  noAttention: 'No hay fallos ni pruebas pendientes de ejecutar que destacar.',
  showing: 'Mostrando',
  of: 'de',
  breakdown: 'Distribución de fallos',
  breakdownHint: 'Proyectos con más ejecuciones fallidas en el período.',
  noFailures: 'Sin ejecuciones fallidas en este período.',
  health: 'Estado por proyecto',
  healthHint:
    'Los conteos de ejecuciones usan el período seleccionado. Los fallos actuales usan el último resultado completado.',
  tests: 'Pruebas',
  completedShort: 'Completadas',
  failingShort: 'Con fallos',
  neverShort: 'Nunca ejecutadas',
  lastRun: 'Última ejecución',
  noProjects: 'Todavía no hay pruebas en este alcance.',
  activity: 'Actividad reciente',
  activityHint: 'Últimas ejecuciones en el período seleccionado.',
  noActivity: 'Sin actividad de ejecuciones en este período.',
  history: 'Abrir historial de la prueba',
  openError: 'No se pudo abrir la prueba. Actualiza e inténtalo de nuevo.',
  uncategorized: 'Sin categoría',
  unavailable: 'Proyecto no disponible',
  filtersHint:
    'Solo se incluyen pruebas a las que tienes acceso. Las pendientes, en ejecución, canceladas y sin ejecutar no cuentan para la tasa de éxito.',
  status: {
    pass: 'Aprobada',
    passed: 'Aprobada',
    fail: 'Fallida',
    failed: 'Fallida',
    error: 'Error',
    pending: 'Pendiente',
    running: 'En ejecución',
    cancelled: 'Cancelada',
    canceled: 'Cancelada',
    unknown: 'Desconocido',
  },
};

export const qualityCopy = (language) => (language === 'es' ? es : en);
export const projectName = (project, copy) =>
  project.id === 'unassigned'
    ? copy.uncategorized
    : project.name === 'Unavailable project'
      ? copy.unavailable
      : project.name;
